import { useCurrentUser } from 'hooks/auth';
import { useIsCurrentUserOmni } from 'hooks/auth/useIsCurrentUserOmni';
import { useIsUsCurrentTalent } from 'hooks/talents/useCurrentTalentRegion';
import { useIsPaidTalentAccount } from 'hooks/talents/useTalentAccountType';
import React from 'react';

import { CreateTalentCommnunityMiddleContent } from './CreateTalentCommnunityMiddleContent';
import { PendingVerificationTalentContent } from './PendingVerificationTalentContent';

interface MiddleContentProps {}

export const MiddleContent = (props: MiddleContentProps) => {
  const { data } = useCurrentUser();
  const isOmniAccount = useIsCurrentUserOmni();
  const isPaidTalent = useIsPaidTalentAccount();
  const isUsCurrentTalent = useIsUsCurrentTalent();
  const talent = data?.currentTalent;

  if (!!talent && !isPaidTalent && !isOmniAccount) {
    return <PendingVerificationTalentContent />;
  }

  if (!!talent && !isOmniAccount && !isUsCurrentTalent) {
    return <CreateTalentCommnunityMiddleContent />;
  }
  return <div></div>;
};
